<template>
  <div id="main">
    <div id="title-block">
      <div id="info" class="header-menu" v-on:click="openInfoModal()">
        INFO
        <div id="info-new" v-if="isNew()">●</div>
      </div>
      <div id="contact" class="header-menu" v-if="canContact()" v-on:click="openContactModal()">
        CONTACT
      </div>
      <div id="title">
        リシュリューの任務マネージャ
      </div>
      <div id="title-color">
        <div id="color-1"></div>
        <div id="color-2"></div>
        <div id="color-3"></div>
      </div>
    </div>
    <div id="tool-block-1">
      <div id="type-toggle" class="toggle-area" @click="resetTypeFilter()">
        <img src="../../static/assets/toggle-button.png" alt="toggle" title="toggle" class="toggle-button">
      </div>
      <input type="checkbox" id="filter-factory" v-model="typeFilters" value="factory">
      <label for="filter-factory" class="filter-label">編成</label>
      <input type="checkbox" id="filter-sortie" v-model="typeFilters" value="sortie">
      <label for="filter-sortie" class="filter-label">出撃</label>
      <input type="checkbox" id="filter-exercise" v-model="typeFilters" value="exercise">
      <label for="filter-exercise" class="filter-label">演習</label>
      <input type="checkbox" id="filter-expedition" v-model="typeFilters" value="expedition">
      <label for="filter-expedition" class="filter-label">遠征</label>
      <input type="checkbox" id="filter-supply-repair" v-model="typeFilters" value="supply_repair">
      <label for="filter-supply-repair" id="supply-repair-button" class="filter-label">補/入</label>
      <input type="checkbox" id="filter-arsenal" v-model="typeFilters" value="arsenal">
      <label for="filter-arsenal" class="filter-label">工廠</label>
      <input type="checkbox" id="filter-refurbishment" v-model="typeFilters" value="refurbishment">
      <label for="filter-refurbishment" class="filter-label">改装</label>
      <div id="search-button" v-on:click="openSearchModal()">詳細検索</div>
    </div>
    <div id="tool-block-2">
      <div id="period-toggle" class="toggle-area" @click="resetPeriodFilter()">
        <img src="../../static/assets/toggle-button.png" alt="toggle" title="toggle" class="toggle-button">
      </div>
      <input type="checkbox" id="daily" v-model="periodFilters" value="daily">
      <label for="daily" class="filter-label">日</label>
      <input type="checkbox" id="weekly" v-model="periodFilters" value="weekly">
      <label for="weekly" class="filter-label">週</label>
      <input type="checkbox" id="monthly" v-model="periodFilters" value="monthly">
      <label for="monthly" class="filter-label">月</label>
      <input type="checkbox" id="quarterly" v-model="periodFilters" value="quarterly">
      <label for="quarterly" class="filter-label">四</label>
      <input type="checkbox" id="yearly" v-model="periodFilters" value="yearly">
      <label for="yearly" class="filter-label">年</label>
      <input type="checkbox" id="once" v-model="periodFilters" value="once">
      <label for="once" class="filter-label">単</label>
      <div id="filter-margin"></div>
    </div>
    <div id="tool-block-3">
      <div id="sort-select">
        <select id="sort-list" v-model="questSort">
          <option v-for="option in sortOptions" v-bind:value="option.value" v-bind:key="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>
      <div id="limited-area">
        <input type="checkbox" id="permanent" v-model="limitedFilters" value="permanent">
        <label for="permanent" class="limited-label">常設任務</label>
        <input type="checkbox" id="limited" v-model="limitedFilters" value="limited" @click="controlFinished()">
        <label for="limited" class="limited-label">期間限定</label>
        <input type="checkbox" id="finished" v-model="limitedFilters" value="finished" @click="controlLimited()">
        <label for="finished" class="limited-label">終了済</label>
      </div>
    </div>
    <div id="quest-list">
      <div v-if="getQuests().length>0">
        <div v-for="(item, key) in getQuests()" :key="key" class="quest-panel">
          <quest-item :item="item" @openQuest="openQuestModal"></quest-item>
        </div>
      </div>
      <div v-else>
        条件に該当する任務はありません
      </div>
    </div>
    <div v-if="env !== 'production'">{{env}}</div>
    <div>
      <quest-modal :showContent="showQuestModal" :quest="getModalQuest()" @close="closeQuestModal"></quest-modal>
    </div>
    <div>
      <info-modal :showContent="showInfoModal" @close="closeInfoModal"></info-modal>
    </div>
    <div>
      <contact-modal :showContent="showContactModal" @close="closeContactModal"></contact-modal>
    </div>
    <div>
      <search-modal :showContent="showSearchModal" @close="closeSearchModal"></search-modal>
    </div>
  </div>
</template>

<script>
import QuestModal from './QuestModal'
import InfoModal from './InfoModal'
import ContactModal from './ContactModal'
import SearchModal from './SearchModal'
import QuestItem from './manager_main/QuestItem'
import utilsMixin from './manager_main/utils.js'
export default {
  name: 'ManagerMainLg',
  mixins: [utilsMixin],
  components: {
    QuestItem,
    QuestModal,
    InfoModal,
    ContactModal,
    SearchModal
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
:root {
  --outline-color: black
}
#main {
  width: 1080px;
  display: inline-block;
}
#title-block {
  height: 30px;
  display: flex;
  border: 1px solid;
  border-image: linear-gradient(to bottom right, #877325, #C0B578);
  border-image-slice:1;
  background-color:#393836;
}
.header-menu {
  padding: 0 8px;
  color: #FFFFFF;
  line-height: 32px;
  text-align: center;
  font-size: 10pt;
  text-shadow: 0 0 4px #359799; /* フォントの影を指定 */
  font-weight: bold;
  -webkit-text-stroke: 1px #359799; /* フォントのアウトラインを指定 */
  border-left: solid;
  border-left-width: 1px;
  border-left-color: #565656;
  border-right: solid;
  border-right-width: 1px;
  border-right-color: #353535;
  cursor: pointer;
  position: relative;
}
#info-new {
  background     : #ff0000;            /* 背景色                  */
  color          : #ffffff;            /* 文字色                  */
  font-weight    : bold;               /* 太字                    */
  font-size      : 10pt;               /* ベースの文字サイズ      */
  letter-spacing : -1px;               /* 文字間隔詰め            */
  line-height    : 1;                  /* 1行の高さ               */
  vertical-align : top;                /* 基準の高さ位置          */
  margin         : 0;                  /* 外余白なし              */
  padding        : 2px;                /* 反転時の内余白          */
  transform      : scale(0.8);          /* 文字サイズ変更          */
  /* ブリンクのアニメ指定    */
  animation      : newAnime .7s infinite alternate;
  position: absolute;
  top: 0;
  right: 0;
}
@keyframes newAnime {
  0% { color      : #ff0000;          /* ブリンク時の文字色      */
    background : #ffffff;          /* ブリンク時の背景色      */
  }
  100% { color      : #ffffff;          /* ブリンク時の文字色      */
    background : #ff0000;          /* ブリンク時の背景色      */
  }
}

#title {
  color: #FFFFFF;
  line-height: 32px;
  text-align: center;
  font-size: 14pt;
  flex: 1;
  border-left: solid;
  border-left-width: 1px;
  border-left-color: #565656;
  border-right: solid;
  border-right-width: 1px;
  border-right-color: #353535;
}
#title-color {
  display: flex;
  width: 60px;
}
#color-1 {
  width: 20px;
  background: linear-gradient(to right, #393836, #002395);
}
#color-2 {
  width: 20px;
  background: linear-gradient(to right, #002395, #FFFFFF);
}
#color-3 {
  width: 20px;
  background: linear-gradient(to right, #FFFFFF, #ED2939);
}
/* フィルタのデザインを設定 */
input[type=checkbox] {
  display: none; /* チェックボックスを非表示にする */
}
.filter-label { /* フィルタの基本デザイン：オフ */
  display: block; /* ブロックレベル要素化する */
  float: left; /* 要素の左寄せ・回り込を指定する */
  width: 60px; /* ラベルの横幅を指定する */
  height: 40px; /* ラベルの高さを指定する */
  font-size: 18pt;
  line-height: 40px;
  text-align: center; /* テキストのセンタリングを指定する */
  cursor: pointer; /* マウスカーソルの形（リンクカーソル）を指定する */
  color: #898989; /* フォントの色を指定 */
  text-shadow: 0 0 4px var(--outline-color); /* フォントの影を指定 */
  font-weight: bold;
  -webkit-text-stroke: 1px var(--outline-color); /* フォントのアウトラインを指定 */
  border-left: solid;
  border-left-width: 2px;
  border-left-color: #525252;
  border-right: solid;
  border-right-width: 2px;
  border-right-color: #4D4D4D;
}
#tool-block-1 { /* 任務タイプ：背景・配置 */
  height: 40px;
  display: flex;
  border: 1px solid;
  border-image: linear-gradient(to bottom right, #877325, #C0B578);
  border-image-slice:1;
  background-color:#393836;
}
#tool-block-1 > input[type="checkbox"]:checked + label { /* 任務タイプ：共通：オン */
  color: #FFFFFF;
  font-size: 18pt;
  line-height: 40px;
}
#tool-block-1 > input[type="checkbox"]#filter-factory:checked + label { /* 編成 */
  background-image: linear-gradient(to bottom, #56C16C, #3F7A4D);
  border-left-color: #56C16C;
  border-right-color: #3F7A4D;
  --outline-color: #153018;
}
#tool-block-1 > input[type="checkbox"]#filter-sortie:checked + label { /* 出撃 */
  background-image: linear-gradient(to bottom, #F26C6D, #B93B38);
  border-left-color: #F26C6D;
  border-right-color: #B93B38;
  --outline-color: #6C120F;
}
#tool-block-1 > input[type="checkbox"]#filter-exercise:checked + label { /* 演習 */
  background-image: linear-gradient(to bottom, #9CD073, #479334);
  border-left-color: #9CD073;
  border-right-color: #479334;
  --outline-color: #1E3813;
}
#tool-block-1 > input[type="checkbox"]#filter-expedition:checked + label { /* 遠征 */
  background-image: linear-gradient(to bottom, #50C6C5, #369B96);
  border-left-color: #50C6C5;
  border-right-color: #369B96;
  --outline-color: #052F2E;
}
#tool-block-1 > input[type="checkbox"]#filter-supply-repair:checked + label { /* 補給, 入渠 */
  background-image: linear-gradient(to bottom, #E2C873, #BF9B3F);
  border-left-color: #E2C873;
  border-right-color: #BF9B3F;
  --outline-color: #5B3D21;
}
#tool-block-1 > input[type="checkbox"]#filter-arsenal:checked + label { /* 工廠 */
  background-image: linear-gradient(to bottom, #946B50, #62423A);
  border-left-color: #946B50;
  border-right-color: #62423A;
  --outline-color: #1F0E09;
}
#tool-block-1 > input[type="checkbox"]#filter-refurbishment:checked + label { /* 改装 */
  background-image: linear-gradient(to bottom, #D5AEE2, #A27EB4);
  border-left-color: #D5AEE2;
  border-right-color: #A27EB4;
  --outline-color: #593C68;
}
#tool-block-2 { /* 任務発生特性タイプ：背景・配置 */
  height: 40px;
  display: flex;
  border: 1px solid;
  border-image: linear-gradient(to bottom right, #877325, #C0B578);
  border-image-slice:1;
  background-color:#393836;
}
#tool-block-2 > input[type="checkbox"]:checked + label { /* 任務発生特性タイプ：共通：オン */
  font-size: 18pt;
  line-height: 40px;
  background-image: linear-gradient(to bottom, #D0D2D2, #B5B7B7);
  border-left-color: #D0D2D2;
  border-right-color: #B5B7B7;
}
#tool-block-2 > input[type="checkbox"]#daily:checked + label { /* 日 */
  color: #71BFFD;
  --outline-color: #24364D;
}
#tool-block-2 > input[type="checkbox"]#weekly:checked + label { /* 週 */
  color: #74D4E0;
  --outline-color: #2F5565;
}
#tool-block-2 > input[type="checkbox"]#monthly:checked + label { /* 月 */
  color: #B7E161;
  --outline-color: #243F33;
}
#tool-block-2 > input[type="checkbox"]#quarterly:checked + label { /* 四 */
  color: #DF9B61;
  --outline-color: #40382B;
}
#tool-block-2 > input[type="checkbox"]#yearly:checked + label { /* 年 */
  color: #FFFFFF;
  --outline-color: #292725;
}
#tool-block-2 > input[type="checkbox"]#once:checked + label { /* 単 */
  color: #EED952;
  --outline-color: #41433A;
}
#filter-margin {
  width: 64px;
}
#tool-block-3 { /* ソートタイプ：背景・配置 */
  height: 40px;
  display: flex;
  border: 1px solid;
  border-image: linear-gradient(to bottom right, #877325, #C0B578);
  border-image-slice:1;
  background-color:#393836;
}
#sort-select {

}
#sort-list {
  height: 30px;
  margin-top: 5px;
  margin-left: 5px;
  outline: none;
  color: #FFFFFF;
  background: #393836;
}
.toggle-area {
  width: 40px;
  background-color: #393836;
  color: #FFFFFF;
  border-left: solid;
  border-left-width: 2px;
  border-left-color: #525252;
  border-right: solid;
  border-right-width: 2px;
  border-right-color: #4D4D4D;
}
.toggle-area:hover {
  background-color: #606060;
  cursor: pointer;
}
.toggle-button {
  width: 32px;
  height: 32px;
  margin-top: 4px;
}
#search-button {
  margin-left: auto;
  width: 72px;
  background-color: #393836;
  color: #FFFFFF;
  padding-top: 10px;
  line-height: 20px;
  border-left: solid;
  border-left-width: 2px;
  border-left-color: #525252;
  border-right: solid;
  border-right-width: 2px;
  border-right-color: #4D4D4D;
}
#search-button:hover {
  background-color: #606060;
  cursor: pointer;
}
#limited-area {
  margin-left: auto;
}
#limited-area > input[type="checkbox"]:checked + label {
  color: #FFFFFF;
  line-height: 40px;
  background-image: linear-gradient(to bottom, #338182, #4EA6A5);
  border-left-color: #7CBBBB;
  border-right-color: #617E7E;
  --outline-color: #393634;
}
.limited-label {
  display: block; /* ブロックレベル要素化する */
  float: left; /* 要素の左寄せ・回り込を指定する */
  width: 72px; /* ラベルの横幅を指定する */
  height: 40px; /* ラベルの高さを指定する */
  line-height: 40px;
  text-align: center; /* テキストのセンタリングを指定する */
  cursor: pointer; /* マウスカーソルの形（リンクカーソル）を指定する */
  color: #898989; /* フォントの色を指定 */
  border-left: solid;
  border-left-width: 2px;
  border-left-color: #525252;
  border-right: solid;
  border-right-width: 2px;
  border-right-color: #4D4D4D;
}
#quest-list {
  border: 1px solid;
  border-image: linear-gradient(to bottom right, #877325, #C0B578);
  border-image-slice: 1;
  background-color: #F4EAE0;
  height: 550px;
  text-align: center;
  overflow: auto;
}
.quest-panel {
  position: relative;
  background-color: #E5D5C4;
  height: 80px;
  padding: 8px 8px;
  margin: 10px;
}
.quest-panel:hover {
  cursor: pointer;
  background-color: #E1CFBB;
}
</style>



// WEBPACK FOOTER //
// src/components/ManagerMainLg.vue